import { useLoad } from "@redotech/react-util/load";
import { createContext, useContext, useState } from "react";
import { OrderContext } from "../app/order";
import { SettingsContext } from "../app/settings";
import { handleCreateCart } from "../utils/storefront-cart";

const StorefrontCartContext = createContext<{
  shopifyStorefrontCart: any;
  setShopifyStorefrontCart: (shopifyStorefrontCart: any) => void;
}>({
  shopifyStorefrontCart: undefined,
  setShopifyStorefrontCart: (shopifyStorefrontCart: any) => {},
});

const StorefrontCartContextProvider = ({ children }) => {
  const [shopifyStorefrontCart, setShopifyStorefrontCart] = useState(null);
  const order = useContext(OrderContext);
  const settings = useContext(SettingsContext);

  useLoad(async () => {
    let cart = {};
    if (order && settings?.hasStorefrontAccess) {
      cart = await handleCreateCart(settings, order);
    }
    setShopifyStorefrontCart(cart);
  }, [order, settings]);

  return (
    <StorefrontCartContext.Provider
      value={{
        shopifyStorefrontCart,
        setShopifyStorefrontCart,
      }}
    >
      {children}
    </StorefrontCartContext.Provider>
  );
};

export { StorefrontCartContext, StorefrontCartContextProvider };
